module.exports = __webpack_public_path__ + "img/9788961705301.dcbdab08.jpg";